import { ImportedCustomEventSchema } from "types/customEvents";

export const prepareExportCustomEventSchemasJson = (
  schemas: ImportedCustomEventSchema[],
) => {
  return schemas.map((item) => ({
    eventType: item.eventType,
    name: item.name,
    schema: {
      fields: item.schema.fields,
    },
    active: item.active,
  }));
};
